import { Stack, Typography } from '@mui/material';

import { Icon } from '@/components/shared/icon';

export type TagStatus = 'active' | 'inactive' | 'pending' | 'error';

export interface TagColors {
  color: string;
  backgroundColor: string;
}

export const StatusTag = ({
  status,
  label,
  icon,
  colors,
}: {
  status: TagStatus;
  label: string;
  icon: string;
  // A surface where these statuses carry a different urgency can override the pair for the ones it
  // reads differently; anything left out keeps the console-wide colours.
  colors?: TagColors;
}) => {
  const defaultBackgroundColor =
    status === 'active'
      ? 'var(--mui-palette-custom-LIGHT-GREEN-OPACITY-20)'
      : status === 'inactive'
        ? 'var(--mui-palette-custom-GREY-OPACITY)'
        : status === 'pending'
          ? 'var(--mui-palette-custom-ORANGE-07)'
          : 'var(--mui-palette-background-default)';
  const defaultColor =
    status === 'active'
      ? 'var(--mui-palette-custom-DARK-GREEN-01)'
      : status === 'inactive'
        ? 'var(--mui-palette-custom-GREY-01)'
        : status === 'pending'
          ? 'var(--mui-palette-custom-ORANGE-01)'
          : 'var(--mui-palette-custom-GREY-01)';
  const backgroundColor = colors?.backgroundColor ?? defaultBackgroundColor;
  const color = colors?.color ?? defaultColor;

  return (
    <Stack
      direction='row'
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '8px',
        padding: '4px 12px 4px 4px',
        borderRadius: '4px',
        backgroundColor,
      }}
    >
      <Icon color={color} iconClass={icon} />
      <Typography
        variant='subtitle1Strong'
        noWrap
        sx={{
          // Tags sit inside accordion rows whose summary styles restyle every Typography, so the label outranks them.
          '&&&': {
            color,
            fontWeight: 500,
          },
        }}
      >
        {label}
      </Typography>
    </Stack>
  );
};
